import { createContext } from "react";

const IdentityDocumentContext = createContext({});

export default IdentityDocumentContext;
